// extracted by mini-css-extract-plugin
module.exports = {"documentModal":"DIwYcjcF","contentWrapper":"y0LyH0Vu","skeletonLoaderWrapper":"N67tMh6Z"};